import "./Finance.scss";
import { Col, Container, Row } from "reactstrap";
import "nouislider/distribute/nouislider.css";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import BreadCrumb from "Components/Common/BreadCrumb";
import Icomeover from "./Components/Icomeover";
import Statement from "./Components/statement";
import DetailStatement from "./Components/DetailStatement";
import { useEffect, useState } from "react";
import {
  getIncomeDetailThunk,
  getIcomeOverViewThunk,
  getOrderIncomeStatementThunk,
} from "live-slices/OrderStatements/thunks";
import { createSelector } from "reselect";
import ErrorModal from "Components/Common/ErrorModal";
import BreadCrumbforback from "Components/Common/BreadCrumbForBack";

const MyIncome = (props: any) => {
  const [activeBar, setActiveBar] = useState<any>("incomeOverview");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const itemsPerPage = 10;
  const [search, setSearchQuery] = useState("");
  const [starDate, setStarDate] = useState<number>(0);
  const [endDate, setEndDate] = useState<number>(0);
  const [incomeDetailStartDate, setIncomeDetailStartDate] = useState<number>(0);
  const [incomeDetailEndDate, setIncomeDetailEndDate] = useState<number>(0);
  const [orderId, setOrderId] = useState("");
  const [keywordType, setKeywordType] = useState("");
  const [search2, setSearchQuery2] = useState("");
  const [search3, setSearchQuery3] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const dispatch: any = useDispatch();
  const [counts, setCounts] = useState<any>();
  const [releaseAmmount, setReleaseAmmount] = useState<any>();
  const [status, setStatus] = useState("");
  const [otherIcomeList, setotherIncomeList] = useState<any>([]);
  const [incomDetailList, IsetncomDetailList] = useState<any>([]);
  const [incomDetailCount, IsetncomDetailCount] = useState<any>([]);
  const [orderIncomeStatementList, setOrderIncomeStatementList] = useState<any>(
    []
  );
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [releaseCount, setReleaseCount] = useState<number>(0);
  const [toBereleaseCount, setToBeReleaseCount] = useState<number>(0);
  const [showModal, setShowModal] = useState({
    isVisible: false,
    color: false,
  });

  const selectIcomeData = createSelector(
    (state: any) => state.OverViewStatement,
    (IcomeOverView) => IcomeOverView?.IcomeOverView
  );
  const allIcome = useSelector(selectIcomeData);

  const incomDetailListData = createSelector(
    (state: any) => state.OverViewStatement,
    (IncomeDetailList) => IncomeDetailList?.IncomeDetailList
  );
  const allIcomeDetail = useSelector(incomDetailListData);

  const orderIncomeStatementListData = createSelector(
    (state: any) => state.OverViewStatement,
    (orderStatementIncome) => orderStatementIncome?.orderStatementIncome
  );
  const allIncomeStatement = useSelector(orderIncomeStatementListData);

  
        useEffect(() => {
  const debounceTyping = setTimeout(() => {
    if (activeBar === "incomeOverview") {
      fetchIcome();
    } else if (activeBar === "incomeStatement") {
      fetchOrderIncomeStatement();
    } else if (activeBar === "incomeDetail") {
      fetchIcomeDetail();
    }
  }, 500);

  return () => clearTimeout(debounceTyping);
}, [search,search2,search3,currentPage,]);

  useEffect(() => {
    if (activeBar === "incomeOverview") {
      fetchIcome();
    } else if (activeBar === "incomeStatement") {
      fetchOrderIncomeStatement();
    } else if (activeBar === "incomeDetail") {
      fetchIcomeDetail();
    }
    IsetncomDetailList(allIcomeDetail);
  }, [activeBar,   selectedStatus , starDate, endDate, incomeDetailStartDate, incomeDetailEndDate, currentPage]);

  const fetchIcome = async () => {
    const resp = await dispatch(
      getIcomeOverViewThunk({
        page: currentPage,
        count: itemsPerPage,
        starDate: starDate,
        endDate: endDate,
        orderId:orderId,
        status: selectedStatus,
        keywordType:keywordType,
        keyword: search,
      })
    );

    if (resp?.payload) {
      setCounts(resp.payload.toBeReleasedAmount);
      setReleaseAmmount(resp.payload.releasedAmount)
      setotherIncomeList(resp.payload.data);
      setReleaseCount(resp?.payload?.releasedCount)
      setToBeReleaseCount(resp?.payload?.toBeReleasedCount)
    } else {
    }
  };

  const fetchIcomeDetail = async () => {
    const resp = await dispatch(
      getIncomeDetailThunk({
        page: currentPage,
        count: itemsPerPage,
        starDate: incomeDetailStartDate,
        endDate: incomeDetailEndDate,
        keyword: search3,
        status: selectedStatus,
        keywordType: "orderId",
      })
    );

    if (resp.payload) {
      setCounts(resp.payload.counts);
      IsetncomDetailList(resp.payload.data);
      IsetncomDetailCount(resp.payload);
    } else {
    }
  };

  const fetchOrderIncomeStatement = async () => {
    const resp = await dispatch(
      getOrderIncomeStatementThunk({
        page: currentPage,
        count: itemsPerPage,
        keyword: search2,
        status: selectedStatus,
      })
    );
    if (resp.payload) {
      setCounts(resp.payload.counts);
      // setOrderIncomeStatementList(resp.payload.data);
    } else {
    }
  };

  const handleSearchIncomeOverview = (query: any) => {
    setSearchQuery(query);
  };
  const handleSearchIncomeStatement = (query: any) => {
    setSearchQuery2(query);
  };
  const handleSearchIncomeDetail = (query: any) => {
    setSearchQuery3(query);
  };
   const handleStartDate = (startDate: any) => {
    setStarDate(startDate);
  };
   const handleEndDate = (endDate: any) => {
    setEndDate(endDate);
  };
    const handleStartDateDetail = (incomeDetailStartDate: any) => {
    setIncomeDetailStartDate(incomeDetailStartDate);
  };
   const handleEndDateDetail = (incomeDetailEndDate: any) => {
    setIncomeDetailEndDate(incomeDetailEndDate);
  };

  const handelResetOrder=()=>{
    setStarDate(0);
    setEndDate(0);
    setSelectedStatus("");
    setSearchQuery("");
  }

  const handleResetIncomeDetail = () => {
    setIncomeDetailStartDate(0);
    setIncomeDetailEndDate(0);
    setSelectedStatus("");
    setSearchQuery3("");
   }
  

  const handleTagTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setSelectedStatus(value);
    if (selectedStatus === "releasedtobe") {
      setErrorMessage("Status Changed to Released");
      setShowModal({ isVisible: true, color: true });
      setTimeout(() => {
        setShowModal({ isVisible: false, color: true });
      }, 1000);
    } else if (selectedStatus === "released") {
      setErrorMessage("Status Changed to Released To Be");
      setShowModal({ isVisible: true, color: true });
      setTimeout(() => {
        setShowModal({ isVisible: false, color: true });  
      }, 1000);
    }
  };

  const handleReset = () => {
  setSearchQuery("");
  setSearchQuery3("");
  setSelectedStatus("");  
  setErrorMessage("All fields have been reset.");
  setShowModal({ isVisible: true, color: true });
  setTimeout(() => {
    setShowModal({ isVisible: false, color: true });
  }, 1000);
};


  document.title = "My Income | BuyPass";

  return (
    <>
      <ErrorModal
        show={showModal.isVisible}
        message={errorMessage}
        color={showModal.color}
        onCloseClick={() => setShowModal({ isVisible: false, color: false })}
      />
      <div className="page-content page-content-mobile financeMainDv">
        <ToastContainer closeButton={false} limit={1} />

        <Container fluid>
          <BreadCrumbforback
            title="My Income"
            pageTitle="My Income"
            pageTitleRoute="/my-income"
          />
          <Row>
            <div className="navigatiovCardDv mb-2">
              <div className="d-flex gap-4">
                <p
                  onClick={() => setActiveBar("incomeOverview")}
                  className={
                    activeBar === "incomeOverview" ? "borderbottom" : "parap"
                  }
                  data-testing-id="incomeOverview"
                >
                  Income Overview
                </p>
                <p
                  onClick={() => setActiveBar("incomeStatement")}
                  className={
                    activeBar === "incomeStatement" ? "borderbottom" : "parap"
                  }
                                    data-testing-id="incomeStatement"

                >
                  Income Statement
                </p>
                <p
                  onClick={() => setActiveBar("incomeDetail")}
                  className={
                    activeBar === "incomeDetail" ? "borderbottom" : "parap"
                  }
                                                      data-testing-id="incomeDetail"

                >
                  Income Details
                </p>
              </div>
            </div>
            {/* <Col xl={12} lg={12}>
            <div className="overView">
              <Card className="p-3">
                <h6>Income Overview</h6>

                <div className="inCome">
                  <div className="Releasrd">
                    <div>
                      {" "}
                      <h6>To be Released</h6>
                      <span></span>
                    </div>

                    <h3>
                      RS: <span>33,435</span>
                    </h3>
                    <div className="leaD">
                      <div className="TOBE">
                        <p>To be released on 12 May 2025</p>
                        <span>
                          <img src={Warning} alt="" />
                        </span>
                      </div>
                      <h5>
                        Rs. <span>33,435</span>
                      </h5>
                    </div>
                  </div>

                  <div className="Releasrd">
                    <div>
                      {" "}
                      <h6>Released</h6>
                      <span></span>
                    </div>

                    <h3>
                      RS: <span>33,435</span>
                    </h3>
                    <div>
                      <div className="leaD">
                        <div className="TOBE">
                          <p>To be released on 12 May 2025</p>
                          <span>
                            <img src={Warning} alt="" />
                          </span>
                        </div>
                        <h5>
                          Rs. <span>33,435</span>
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </Card>
            </div>
          </Col>
          <Col xl={12} lg={12}>
            <div className="navigatiovCardDv">
              <Card className="p-3 w-100">
                <Nav
                  className="nav-tabs nav-tabs-custom nav-success"
                  role="tablist"
                >
                  <NavItem>
                    <NavLink
                      className="classnames"
                      href="#"
                      data-testing-id="all_IndexDeal"
                    >
                      To be Released 12
                      <span className="badge paddingBadge bg-danger-subtle text-danger align-middle rounded-pill ms-1"></span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className="classnames"
                      href="#"
                      data-testing-id="pending_IndexDeal"
                    >
                      Released 12
                      <span className="badge paddingBadge bg-danger-subtle text-danger align-middle rounded-pill ms-1"></span>
                    </NavLink>
                  </NavItem>
                </Nav>
                <div className="AndSelect">
                  <div className="searchAndSelect">
                    <input
                      className="select"
                      type="text"
                      placeholder="Order ID"
                      data-testing-id="inventryName/IdInput_PrizeInventory"
                    />

                    <div className="input">
                      <input
                        type="text"
                        placeholder="Search"
                        data-testing-id="inventryName/IdInput_PrizeInventory"
                      />
                      <img
                        src={searchIcon}
                        alt="search"
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  </div>{" "}
                  <div className="searchAndSelect">
                    <input
                      className="select"
                      type="text"
                      placeholder="Release Status"
                      data-testing-id="inventryName/IdInput_PrizeInventory"
                    />

                    <div className="input">
                      <input
                        type="text"
                        placeholder="Search"
                        data-testing-id="inventryName/IdInput_PrizeInventory"
                      />
                      <img
                        src={searchIcon}
                        alt="search"
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  </div>{" "}
                  <div className="select-And-Inputs">
                    <select
                      // value={status}
                      data-testing-id="statusSelect_PromotionListing"
                    >
                      <option
                        value=""
                        data-testing-id="selectStatusOption_PromotionListing"
                      >
                        Select Status
                      </option>
                      <option
                        value="true"
                        data-testing-id="activeOption_PromotionListing"
                      >
                        Active
                      </option>
                      <option
                        value="false"
                        data-testing-id="inactiveOption_PromotionListing"
                      >
                        Inactive
                      </option>
                    </select>
                    <div>
                      <button>Reset</button>
                    </div>
                  </div>
                </div>
                <div className="GirdWidth mt-3">
                  <div className="girdOne">
                    <input type="checkbox" />
                    <p>Orders Details</p>
                  </div>
                  <div className="girdTwo">
                    <p>Order Creation Date</p>
                  </div>
                  <div className="girdThree">
                    <p>Order Status</p>
                  </div>
                  <div className="girdFour">
                    <p>Est Release Amount</p>
                  </div>
                  <div className="girdFive">
                    <p>Release Status</p>
                  </div>
                  <div className="girdSix">
                    <p>Statement Number</p>
                  </div>
                  <div className="girdSeven">
                    <p>Action</p>
                  </div>
                </div>
              </Card>
            </div>
          </Col> */}
            <Col xl={12} lg={12}>
              {/* <div className="orderDetail">
              <Card className="p-3">
                <div className="GirdWidth ">
                  <div className="girdOne">
                    <input type="checkbox" />
                    <div className="boX">
                      <img src={OrderIcon} alt="" />
                      <div>
                        <p>Portable Toothbrush amp...</p>
                        <p className="potable">
                          Order Number: TS148....495345{" "}
                          <span>
                            <img src={Mobile} alt="" />
                          </span>
                        </p>
                        <p className="potable">
                          Order Line ID: TS148....495345:{" "}
                          <span>
                            <img src={Mobile} alt="" />
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="girdTwo">
                    <p>
                      01 Feb 2025 <span>18:00</span>
                    </p>
                  </div>
                  <div className="girdThree">
                    <div className="newOrder">
                      <div className="dot"></div>
                      <p style={{ textTransform: "capitalize" }}>order</p>
                    </div>{" "}
                  </div>
                  <div className="girdFour">
                    <div className="fouth">
                      <div className="Amount">
                        <p>Amount</p>
                        <p className="Rupess">
                          Rs. <span>345.35</span>
                        </p>
                      </div>
                      <div className="free">
                        <h6>Show Fee Details</h6>
                        <img src={DropDown} alt="" />
                      </div>
                    </div>
                  </div>
                  <div className="girdFive">
                    <div className="newOrder">
                      <div className="dot"></div>
                      <p style={{ textTransform: "capitalize" }}>
                        Ready to Release
                      </p>
                    </div>{" "}
                  </div>
                  <div className="girdSix">
                    <p className="potable">
                      Order Number: TS148....495345{" "}
                      <span>
                        <img src={Mobile} alt="" />
                      </span>
                    </p>{" "}
                  </div>
                  <div className="girdSeven">
                    <p>View Orders Details</p>
                    <p>View Statement Details</p>
                  </div>
                </div>
              </Card>
            </div> */}
              {activeBar === "incomeOverview" && (
                <Icomeover
                  IcomeOverView={otherIcomeList}
                  onSearch={handleSearchIncomeOverview}
                  onChange={handleStartDate}
                  onChangeEndDate={handleEndDate}
                  search={search}
                  selectedStatus={selectedStatus}
                  countsRelease={counts}
                  tabCountsToBeRelease={toBereleaseCount}
                  tabReleaseCount={releaseCount}
                  countsReleaseAmmount={releaseAmmount}
                  onStatusChange={handleTagTypeChange}
                  resetBUtton={handelResetOrder}
                />
              )}
              {activeBar === "incomeStatement" && (
                <Statement
                  allIncomeStatementList={allIncomeStatement}
                  onSearch={handleSearchIncomeStatement}
                  onStatusChange={handleTagTypeChange}
                  resetBUtton={handleReset}

                />
              )}
              {activeBar === "incomeDetail" && (
                <DetailStatement
                  allIcomeDetailList={allIcomeDetail}
                  onSearch={handleSearchIncomeDetail}
                  onChange={handleStartDateDetail}
                  onChangeEndDate={handleEndDateDetail}
                  IncomeDetailCount={incomDetailCount}
                  onStatusChange={handleTagTypeChange}
                  resetBUtton={handleResetIncomeDetail}
                  selectedStatus={selectedStatus}
                />
              )}
            </Col>
          </Row>
        </Container>

        <Container fluid style={{ display: "none" }}>
          <BreadCrumb
            title="Manage Products"
            pageTitle="Products"
            pageTitleRoute="/manage-products"
          />

          <button className="btn-add-product">
            <svg
              width="44"
              height="43"
              viewBox="0 0 44 43"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              {" "}
              <path
                d="M31.9813 9.57568L21.9107 4.15716C20.8412 3.58679 19.5757 3.58679 18.5063 4.15716L8.45349 9.57568C7.7227 9.98564 7.25928 10.7699 7.25928 11.6255C7.25928 12.4988 7.70488 13.2831 8.45349 13.6752L18.5241 19.0937C19.0588 19.3789 19.647 19.5215 20.2174 19.5215C20.7878 19.5215 21.3938 19.3789 21.9107 19.0937L31.9813 13.6752C32.7121 13.2831 33.1755 12.4988 33.1755 11.6255C33.1755 10.7699 32.7121 9.98564 31.9813 9.57568Z"
                fill="#0877FF"
              />{" "}
              <path
                d="M16.8665 20.9831L7.50888 16.3132C6.7781 15.9389 5.95819 15.9923 5.26305 16.4023C4.58573 16.8301 4.17578 17.5609 4.17578 18.3629V27.2037C4.17578 28.7366 5.03134 30.109 6.40379 30.8042L15.7614 35.4741C16.0823 35.6345 16.4387 35.7236 16.7952 35.7236C17.2052 35.7236 17.633 35.5988 18.0073 35.3849C18.6846 34.9572 19.0945 34.2264 19.0945 33.4243V24.5835C19.0767 23.0507 18.2212 21.6782 16.8665 20.9831Z"
                fill="#0877FF"
              />{" "}
              <path
                d="M36.2593 18.3629V22.7477C35.4038 22.4981 34.4947 22.3912 33.5857 22.3912C31.1616 22.3912 28.791 23.2289 26.9195 24.7261C24.3528 26.7403 22.8913 29.7882 22.8913 33.0856C22.8913 33.959 22.9982 34.8324 23.2299 35.6701C22.9626 35.6345 22.6952 35.5275 22.4457 35.3671C21.7684 34.9572 21.3584 34.2264 21.3584 33.4243V24.5835C21.3584 23.0507 22.214 21.6782 23.5686 20.9831L32.9262 16.3132C33.657 15.9389 34.4769 15.9923 35.1721 16.4023C35.8494 16.8301 36.2593 17.5609 36.2593 18.3629Z"
                fill="#0877FF"
              />{" "}
              <path
                d="M39.8242 28.0949C39.8242 28.0771 39.8064 28.0593 39.7886 28.0414C39.7173 27.9345 39.6281 27.8276 39.539 27.7384C39.5212 27.7206 39.5034 27.685 39.4855 27.6671C38.0418 26.063 35.9207 25.0648 33.5858 25.0648C31.3399 25.0648 29.2902 25.9917 27.8286 27.4889C26.4205 28.9326 25.5649 30.9111 25.5649 33.0857C25.5649 34.5829 25.9927 36.0088 26.7235 37.2208C27.1156 37.8803 27.6147 38.4863 28.1851 38.9854C28.2207 39.0032 28.2386 39.0211 28.2564 39.0389C28.3455 39.128 28.4346 39.1993 28.5416 39.2884C28.5416 39.2884 28.5416 39.2884 28.5594 39.2884C28.5772 39.3063 28.595 39.3241 28.6129 39.3241C29.9497 40.447 31.6786 41.1065 33.5858 41.1065C36.5089 41.1065 39.0578 39.538 40.448 37.2208C40.858 36.5257 41.1788 35.7593 41.3749 34.9572C41.5353 34.3512 41.6066 33.7273 41.6066 33.0857C41.6066 31.1963 40.9471 29.4495 39.8242 28.0949ZM36.5802 34.3868H34.9226V36.1157C34.9226 36.8465 34.3166 37.4526 33.5858 37.4526C32.855 37.4526 32.249 36.8465 32.249 36.1157V34.3868H30.5913C29.8605 34.3868 29.2545 33.7808 29.2545 33.05C29.2545 32.3192 29.8605 31.7132 30.5913 31.7132H32.249V30.1269C32.249 29.3961 32.855 28.7901 33.5858 28.7901C34.3166 28.7901 34.9226 29.3961 34.9226 30.1269V31.7132H36.5802C37.311 31.7132 37.917 32.3192 37.917 33.05C37.917 33.7808 37.3288 34.3868 36.5802 34.3868Z"
                fill="#FF4F4F"
              />{" "}
            </svg>
            Add New Product
          </button>

          <div className="searchBar">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              {" "}
              <path
                d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />{" "}
              <path
                d="M19 19L17 17"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />{" "}
            </svg>
            <input type="text" placeholder="Search" />
          </div>

          <div className="products-list">
            <h4>Products</h4>
          </div>
        </Container>
      </div>
    </>
  );
};

export default MyIncome;
